
<template>
    <div class="container-fluid mt-3">
        <div class="card ">
            <div class="card-body center grid ">
                <vs-row> 
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="12" class="mb-4">
                        <h3>Grupos académicos</h3>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="right"  offset="0" w="4">
                        <form autocomplete="off">
                            <label class="mb-0" style="padding-left: 10px">Institución</label>
                            <vs-select class="pt-0" filter placeholder="Institución" v-model="institucion" v-if="listInstituciones.length" @input="onChangeInstitucion" >
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <template v-if="listInstituciones.length">
                                    <vs-option v-for="option in listInstituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="right"  offset="0" w="4">
                        <form autocomplete="off">
                            <label class="mb-0" style="padding-left: 10px">Ciclo escolar</label>
                            <vs-select :loading="loadingSelect" class="pt-0" filter placeholder="Ciclo Escolar" v-model="cicloEscolar" :disabled="!listCiclos.length" :key="cicloId" >
                                <template #message-danger v-if="errorFields.includes('ciclo')">
                                    Requerido
                                </template>
                                <template v-if="listCiclos.length">
                                    <vs-option v-for="option in listCiclos" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col> 
                    <vs-col vs-type="flex" vs-justify="center" vs-align="right"  offset="0" w="4">
                        <form autocomplete="off">
                            <label for="nivel" class="mb-0" style="padding-left: 10px">Nivel académico</label>
                            <vs-select :loading="loadingSelect" id="nivel" class="pt-0" filter placeholder="Nivel Académico" v-model="nivelAcademico" :disabled="!listNiveles.length" @input="listarProgramas" :key="nivelId">
                                <template #message-danger v-if="errorFields.includes('nivel')">
                                    Requerido
                                </template>
                                <template v-if="listNiveles.length">
                                    <vs-option v-for="option in listNiveles" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col> 
                </vs-row>
                <vs-row> 
                    <vs-col vs-type="flex" vs-justify="center" vs-align="right"  offset="0" w="4">
                        <label for="nivel" class="mb-0" style="padding-left: 10px">Programa</label>
                        <vs-select :loading="loadingSelect" filter placeholder="Programa" v-model="programa" :disabled="!listProgramas.length" :key="programaId" >
                            <template #message-danger v-if="errorFields.includes('programa')">
                                Requerido
                            </template>
                            <template v-if="listProgramas.length">
                                <vs-option v-for="option in listProgramas" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col sm="12" lg="12">
                        <vs-button
                            class="ml-auto"
                            @click="sanityForm()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="12" >
                        <bloques :institucion="institucion" :ciclo-escolar="cicloEscolar" :programa="programa" :nivel-academico="nivelAcademico" :list-niveles="listNiveles" :list-ciclos="listCiclos" v-model="selected" :ejecutar="ejecutar"></bloques>
                    </vs-col>
                </vs-row>
            </div>
        </div>
    </div>
</template>

<script>
import Bloques from './tables/bloques'
import catalogos from '../../../api/requests/catalogos.js'
 
export default {
    data () {
        return {
            listInstituciones:[],
            institucion: '',
            cicloEscolar: '',
            nivelAcademico: '',
            programa: '',
            listNiveles: [],
            listCiclos: [],
            listProgramas: [],
            cicloId: (new Date()).getTime(),
            nivelId: (new Date()).getTime(),
            programaId: (new Date()).getTime(),
            selected: null,
            loadingSelect: false,
            errorFields: [],
            ejecutar: 0
        }
    },
    async created () {
        try {
            const { data: instituciones } = await catalogos.getInstituciones()
            if (Array.isArray(instituciones)){
                this.listInstituciones = instituciones
            }
        } catch (error) {
        }
    },
    methods: {
        onChangeInstitucion () {
            this.cicloEscolar = ''
            this.nivelAcademico = ''
            this.programa = ''
            this.listNiveles = []
            this.listCiclos = []
            this.listProgramas = []
            this.listarCiclos()
            this.listarNiveles()
        },
        async listarCiclos () {
            if (this.institucion){
                try {
                    this.loadingSelect = true
                    const { data: ciclos } = await catalogos.getCiclosEscolares(this.institucion)
                    this.listCiclos = ciclos
                    this.cicloId = (new Date()).getTime()
                    this.loadingSelect = false
                } catch (error) {
                        
                }
            }else {
                this.listCiclos = []
            }
        },
        async listarNiveles () {
            if (this.institucion){
                try {
                    this.loadingSelect = true
                    const { data: niveles } = await catalogos.getNivelesAcademicos(this.institucion)
                    this.listNiveles = niveles
                    this.nivelId = (new Date()).getTime()
                    this.loadingSelect = false
                } catch (error) {
                        
                }
            }else {
                this.listNiveles = []
            }
        },
        async listarProgramas () {
            if (this.nivelAcademico){
                try {
                    this.loadingSelect = true
                    const { data: programas } = await catalogos.getProgramasByNivel(this.institucion, this.nivelAcademico)
                    this.programa = ''
                    this.listProgramas = programas
                    this.programaId = (new Date()).getTime()
                    this.loadingSelect = false
                } catch (error) {
                        
                }
            }else {
                this.listProgramas = []
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('string', this.institucion)) {
                this.errorFields.push('institucion')
            }
            if (!this.checkByType ('string', this.cicloEscolar)) {
                this.errorFields.push('ciclo')
            }
            if (!this.checkByType ('string', this.nivelAcademico)) {
                this.errorFields.push('nivel')
            }
            if (!this.checkByType ('string', this.programa)) {
                this.errorFields.push('programa')
            }
            if (!this.errorFields.length){
                return this.ejecutar += 1
            } else {
                return null
            }
        },
    },
    components:{
        Bloques
    }
}

</script>


<style >
.mini-icon {
     font-size: 0.7rem !important;
}
.unset-min-width table {
    min-width: unset !important;
}
.left-header-unset-radius header {
    border-radius: 14px 0px 0px 0px !important;
}
.rigth-footer-unset-radius footer {
    border-radius: 0px 0px 14px 0px;
}
.rigth-header-unset-radius header {
    border-radius: 0px 14px 0px 0px !important;
}
.left-footer-unset-radius footer {
    border-radius: 0px 0px 0px 14px;
}
.vs-input-parent {
    padding: 10px 11px 10px 11px;
    justify-content: center;
    min-height: 38px;
    width: 100%;
}
.vs-input-parent input {
    justify-content: center;
    min-height: 38px;
    width: 100%;
}
.vs-select-content {
    padding: 10px 0px 10px 10px;
    width: 100%;
    max-width: 95%;
}
.vs-select__option {
    max-height: none;
}
.vs-select--disabled i {
    pointer-events: none !important;
}
</style>
